// FIN-HUBS: Recebimentos — Contas a Receber + Medições (BM) + Deliberação.
import HubAbas, { HubTab } from '../../components/HubAbas';
import FinanceiroContasReceber from '../FinanceiroContasReceber';
import FinanceiroMedicoes from '../FinanceiroMedicoes';
import FinanceiroDeliberacao from '../FinanceiroDeliberacao';
import CodigosNfReforma from '../financeiro-contas-receber/CodigosNfReforma';

const TABS: HubTab[] = [
  { key: 'contas-receber', label: 'Contas a Receber', perm: 'financeiro.contas_receber.ver', render: () => <FinanceiroContasReceber /> },
  { key: 'medicoes',       label: 'Medições (BM)',    perm: 'financeiro.medicoes_bm.ver',    render: () => <FinanceiroMedicoes /> },
  // Reforma tributária (15/10/2026): padrão de NBS, indicador e classificação
  // por código de serviço. Vê quem vê o CR; grava quem edita (servidor confere).
  { key: 'codigos-nf',     label: '🧾 Códigos da NF',  perm: 'financeiro.contas_receber.ver', render: () => <CodigosNfReforma /> },
  // Deliberação era item G_ADMIN no menu antigo — mantém a restrição na aba.
  { key: 'deliberacao',    label: '⚖️ Deliberação',    perm: 'financeiro.contas_receber.ver', soAdmin: true, render: () => <FinanceiroDeliberacao /> },
];

export default function FinanceiroRecebimentosHub() {
  return <HubAbas tabs={TABS} />;
}
